<template>
  <div>
    <table class="table" v-if="tableReady">
      <thead>
        <tr>
          <th >Main Dealer (MD)<br>Region</th>
          <!-- <th rowspan="2">Pending SIPB</th> -->
          <th>In Transit AHM - MD</th>
          <th>SIPB</th>
          <th>Unfill SIPB</th>
          <th>Warehouse Stock</th>
          <th>DO Pending</th>
          <th>Virtual Stock</th>
          <!-- <th rowspan="2">Pending DO</th> -->
        </tr>
        <tr>
          <!-- <th>Carried</th>
          <th>Virtual</th>
          <th>On-Hand</th>
          <th>Virtual</th> -->
        </tr>
      </thead>

      <tbody v-for="stock in mainDealerData.regionStats" :key="stock.region">
        <tr>
          <td style="text-decoration: underline;"><b>{{ stock.region }}</b></td>
          <td>{{ numberWithCommas(stock.intransit_ahm_md) }}</td>
          <td>{{ mainDealerData.sipbUnfill[stock.region.split("-")[0]] && mainDealerData.sipbUnfill[stock.region.split("-")[0]].jumlah_sipb ? numberWithCommas(mainDealerData.sipbUnfill[stock.region.split("-")[0]].jumlah_sipb) : 0 }}</td>
          <td>{{ mainDealerData.sipbUnfill[stock.region.split("-")[0]] && mainDealerData.sipbUnfill[stock.region.split("-")[0]].unfill ? numberWithCommas(mainDealerData.sipbUnfill[stock.region.split("-")[0]].unfill) : 0 }}</td>
          <td>{{ numberWithCommas(stock.warehouse_stock_onhand) }}</td>
          <td>{{ numberWithCommas(stock.pending_do) }}</td>
          <td>{{ numberWithCommas(stock.virtual_stock) }}</td>
        </tr>

        <template  v-for="karesidenan in mainDealerData.gudang[stock.region]" >
          <tr :key="karesidenan.name" v-if="showEmpty || (parseInt(karesidenan.intransit_ahm_md) > 0 || parseInt(karesidenan.warehouse_stock_onhand) > 0 || parseInt(karesidenan.pending_do) > 0 || parseInt(karesidenan.virtual_stock) > 0 )">
            <td style="text-decoration: underline;">{{ karesidenan.name }} </td>
            <td>{{ numberWithCommas(karesidenan.intransit_ahm_md) }}</td>
            <td>-</td>
            <td>-</td>
            <td>{{ numberWithCommas(karesidenan.warehouse_stock_onhand) }}</td>
            <td>{{ numberWithCommas(karesidenan.pending_do) }}</td>
            <td>{{ numberWithCommas(karesidenan.virtual_stock) }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    data () {
      return {
        tableReady : false,
        mainDealerData : null,
      }
    },
    props:['data' , 'showEmpty'],
    mounted () {
      // console.log('hi');
      this.processData();
    },
    watch : {
      data : {
        deep : true,
        handler : 'processData'
      }
    },
    methods : {
      processData () {
        let mainDealerData = JSON.parse(JSON.stringify(this.data));
        // let mainDealerData = {"gudang":{"M2Z-Surabaya":[{"gudang":"MKT","name":"Gudang Marketing","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":23,"pending_do":"0","virtual_stock":0},{"gudang":"GD1","name":"Gudang Gedangan","region":"M2Z-Surabaya","intransit_ahm_md":3845,"warehouse_stock_onhand":1141,"pending_do":"424","virtual_stock":167},{"gudang":"JBG","name":"Gudang Jombang","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":709,"pending_do":"10","virtual_stock":29},{"gudang":"KPG","name":"Gudang Kupang unit","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":108,"pending_do":"28","virtual_stock":0},{"gudang":"PRB","name":"Gudang Probolinggo","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":486,"pending_do":"147","virtual_stock":192},{"gudang":"GD2","name":"Gudang Gedangan2","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0},{"gudang":"JMD","name":"Gudang Jemundo","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0},{"gudang":"KRN","name":"Gudang Krian","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0},{"gudang":"MD1","name":"Gudang Madiun","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0},{"gudang":"STO","name":"Gudang Suntrako","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":1174,"pending_do":"0","virtual_stock":1170},{"gudang":"XD1","name":"Gudang Simpang Dukuh","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0},{"gudang":"PRB2","name":"GUDANG PROBOLINGGO 2","region":"M2Z-Surabaya","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0}],"M3Z-Malang":[{"gudang":"ML2","name":"Gudang Sewa","region":"M3Z-Malang","intransit_ahm_md":0,"warehouse_stock_onhand":57,"pending_do":"4","virtual_stock":16},{"gudang":"ML1","name":"Gudang Malang","region":"M3Z-Malang","intransit_ahm_md":551,"warehouse_stock_onhand":176,"pending_do":"29","virtual_stock":51},{"gudang":"ML3","name":"Gudang Sewa Krian","region":"M3Z-Malang","intransit_ahm_md":0,"warehouse_stock_onhand":0,"pending_do":"0","virtual_stock":0}]}}
        // console.log(JSON.stringify(mainDealerData));

        let keys = Object.keys(mainDealerData.gudang)
        this.tableReady = true
        mainDealerData.regionStats ? mainDealerData.regionStats.length = 0 : mainDealerData.regionStats = []

        for (var i = 0 ; i < keys.length ; i++) {
          let keysGudang = Object.keys(mainDealerData.gudang[keys[i]][0])
          // console.log(keysGudang);
          let obj = {}

          //Length of array in the region
          for (var j = 0 ; j < mainDealerData.gudang[keys[i]].length ; j++) {
            //Length of object
            for (var k = 0 ; k < keysGudang.length ; k++) {

              //If Region
              if( keysGudang[k] == 'region') {
                obj[keysGudang[k]] = mainDealerData.gudang[keys[i]][j][keysGudang[k]];
                continue
              }

              //If Gudang
              if(keysGudang[k] == 'gudang' || keysGudang[k] == 'name') continue;
              !obj[keysGudang[k]] ? obj[keysGudang[k]] = parseInt(mainDealerData.gudang[keys[i]][j][keysGudang[k]]) : obj[keysGudang[k]] += parseInt(mainDealerData.gudang[keys[i]][j][keysGudang[k]])
              
            }
          }

          mainDealerData.regionStats.push(obj)
        }

        //Convert SIPB/Unfill Into Object Keyed
        let sipbUnfill = {}
        for (var i in mainDealerData.sipb_unfill) {
          //Initialize object key with the name of 'kode_md'
          sipbUnfill[mainDealerData.sipb_unfill[i].kode_md] = {}

          //Loop all key inside the object (j is the key name)
          for (var j in mainDealerData.sipb_unfill[i]) {
            sipbUnfill[mainDealerData.sipb_unfill[i].kode_md][j] = mainDealerData.sipb_unfill[i][j];
          }
        }
        mainDealerData.sipbUnfill = sipbUnfill;

        this.mainDealerData = mainDealerData;
        this.tableReady = true
      }
    }
  }
</script>

<style scoped>
  table tr th, table tr td {
    text-align: center;
    vertical-align: middle;
  }

  table tr th {
    border-bottom: 1px solid #F75047;
  }

</style>